/** Shared Tailwind Typography classes for hub HTML content (Tiptap + legacy WP). */
export const hubProseClassName =
  'prose prose-lg max-w-none text-gray-700 ' +
  'prose-headings:text-gray-900 prose-headings:font-semibold prose-headings:scroll-mt-24 ' +
  'prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 ' +
  'prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-3 ' +
  'prose-p:text-gray-700 prose-p:leading-relaxed prose-p:my-4 ' +
  'prose-a:text-primary prose-a:font-medium hover:prose-a:underline ' +
  'prose-strong:text-gray-900 prose-strong:font-semibold ' +
  'prose-em:text-gray-700 ' +
  'prose-ul:my-4 prose-ul:list-disc prose-ul:pl-6 ' +
  'prose-ol:my-4 prose-ol:list-decimal prose-ol:pl-6 ' +
  'prose-li:text-gray-700 prose-li:my-1 ' +
  'prose-blockquote:border-l-4 prose-blockquote:border-primary/30 prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-gray-600 ' +
  'prose-img:rounded-lg prose-img:max-w-full prose-img:my-6';
